import ShortStatistics from "@/vuex/models/statistics/short";

export default class StatisticsState {
    short!: ShortStatistics;
}
